import React from 'react';
import { Row, Col, Typography, Input, DatePicker } from 'antd';

const { Title, Text } = Typography;

export default function InvoiceHeader({ invoiceData, values, setFieldValue, getInvoiceTypeLabel }) {
    if (!invoiceData) return null;

    return (
        <>
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <Title level={5} style={{ marginBottom: 16, paddingBottom: 8, borderBottom: '2px solid #f0f0f0' }}>
                        DATA INVOICE
                    </Title>
                </Col>
            </Row>

            <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                    <Text strong>Jenis Invoice</Text>
                    <Input
                        value={`BC. ${invoiceData.document_type || '16'} - Invoice ${getInvoiceTypeLabel()}`}
                        disabled
                        style={{ marginTop: 4, backgroundColor: '#f5f5f5' }}
                    />
                </Col>

                <Col xs={24} md={12}>
                    <Text strong>Nomor Invoice</Text>
                    <Input
                        value={values.invoiceNumber || ''}
                        onChange={(e) => setFieldValue('invoiceNumber', e.target.value)}
                        style={{ marginTop: 4 }}
                    />
                </Col>

                <Col xs={24} md={12}>
                    <Text strong>Tanggal Invoice</Text>
                    <DatePicker
                        value={values.invoiceDate}
                        onChange={(v) => setFieldValue('invoiceDate', v)}
                        style={{ width: '100%', marginTop: 4 }}
                        format="DD MMMM YYYY"
                    />
                </Col>

                <Col xs={24} md={12}>
                    <Text strong>Due Date / Jatuh Tempo</Text>
                    <DatePicker
                        value={values.dueDate}
                        onChange={(v) => setFieldValue('dueDate', v)}
                        style={{ width: '100%', marginTop: 4 }}
                        format="DD MMMM YYYY"
                    />
                </Col>
            </Row>
        </>
    );
}
